export default {
    title: "Dodaj ulogu",
    backToLink: {
        text: "Nazad na",
        section: "uloge i korisnike"
    },
    details: {
        title: "Detalji uloge",
        roleName: "Naziv uloge",
        placeholder: "Unesi naziv uloge"
    },
    permissions: "Dozvole",
    allPermissions: 'Sve dozvole',
    users: {
        title: "Korisnici",
        addUserButton: "Dodaj korisnike",
        emptyRole: "Trenutno nemate korisnike u ovoj ulozi. Korisnike možete naknadno dodati."
    },
    button: {
        cancel: "Poništi",
        addRole: "Dodaj ulogu",
    },
    showRole: {
        title: "Uloge i korisnici",
        tabs: {
            roles: "Uloge",
            users: "Korisnici"
        },

        createRole: "Kreiraj ulogu",
        search: "Pretraži uloge",
        deleteRole: "Izbriši",

        table: {
            roleName: "Naziv uloge",
            personsNumber: "Broj ljudi",
            permissions: "Dozvole"
        }
    },
    roleOverview: {
        title: "Pregled uloge",
        editButton: "Izmijeni",
        details: {
            title: "Detalji uloge",
            roleTitle: "Naziv uloge"
        },
        permissions: {
            title: "Dozvole"
        },

        buttons: {
            save: "Sačuvaj",
            cancel: "Poništi"
        }
    },
    userTable: {
        title: "Korisnici",
        username: "Korisničko ime",
        email: "Email",
        roles: "Uloge"
    },
}
